'use client';

import React from 'react';

import { useTranslations } from 'next-intl';

import styles from './styles.module.css';

import { TabNav } from '@/components/TabNav';
import { ShopProfileSection } from '@/modules/activityTracker/constants';
import { type GetShopByUsernameResponse } from '@/modules/shop/aliases';
import { useActiveShopTab } from '@/modules/shop/hooks/useActiveShopTab';
import { useIsViewingOwnShop } from '@/modules/shop/hooks/useIsViewingOwnShop';

type Props = {
  seller: GetShopByUsernameResponse;
};

export function ShopNavigation({ seller }: Props) {
  const tShop = useTranslations('shop');
  const isViewingOwnShop = useIsViewingOwnShop();
  const { tab } = useActiveShopTab();

  const shopHref = `/${seller.username}/`;
  const items = [
    {
      label: tShop(isViewingOwnShop ? 'Selling' : 'Shop'),
      href: shopHref,
      isActive: tab === ShopProfileSection.Shop,
    },
    {
      label: tShop('Likes'),
      href: `${shopHref}${ShopProfileSection.Likes}/`,
      isActive: tab === ShopProfileSection.Likes,
    },
    ...(isViewingOwnShop
      ? [
          {
            label: tShop('Saves'),
            href: `${shopHref}${ShopProfileSection.Saved}/`,
            isActive: tab === ShopProfileSection.Saved,
          },
        ]
      : []),
  ];

  return (
    <div className={styles.wrapper}>
      <TabNav ariaLabel={tShop('NavigationAria')} items={items} />
    </div>
  );
}
